import VanillaTilt from 'vanilla-tilt'
import CONFIG from '@js/config'
import utils from '@js/utils'
import '@js/app'
import scrollbar from '@js/scrollbar'

import '@comp/animate_title/animate_title'
import '@comp/animate_title/animate_title.scss'
import './banner/banner.scss'

import BannerSwiper from '@comp/banner_swiper/banner_swiper'

import compBlockCard from '@comp/block_card/block_card.ejs'
import '@comp/block_card/block_card.scss'

import './style.scss'
import { trackSection } from '@/scripts/ga'

function fetchList (pageCurrent, cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}insights`,
        data: {
            page: pageCurrent,
            limit: 10
        },
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }
            let result = []
            msg.rows.forEach(row => {
                result.push({
                    title: row.insight_category,
                    desc: row.title,
                    bgUrl: row.cover,
                    link: `insight_detail.html?id=${row.id}`,
                    track: `Insight #${row.title}`
                })
            })

            return cb(null, {
                count: result.length,
                rows: result
            })
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

function fetchBanner (cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}feature_insights`,
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }

            let result = []

            msg.forEach(row => {
                result.push({
                    title: row.work_company,
                    desc: row.title,
                    bgUrl: row.slide_banner,
                    link: `insight_detail.html?id=${row.id}`,
                    bgColor: row.bg_color,
                    track: `Featured Insight #${row.title}`
                })
            })

            return cb(null, {
                count: result.length,
                rows: result
            })
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

$(() => {
    trackSection('Insight')
    let pageCurrent = utils.getURLParam('page') || 1

    fetchBanner(function (err, result) {
        if (err) {
            location.href = '404.html'
            return
        }

        let option = {}

        if (result.count <= 1) {
            option = {
                loop: false,
                pagination: false,
                autoplay: false
            }
        }
        const swiper = new BannerSwiper(result.rows, 'insight-banner-swiper', option)
        swiper.init()
    })

    fetchList(pageCurrent, function (err, result) {
        if (err) {
            location.href = '404.html'
            return
        }
        let insightPopularHtml = ''
        result.rows.forEach((item, i) => {
            let html = compBlockCard(item)
            insightPopularHtml += `
                <div class="${i % 5 === 0 ? 'col-sm-8 col-md-8' : 'col-sm-6 col-md-4'} col-xs-12 slideup block-wrap">
                    ${html}
                </div>
            `
        })
        $('#insight-popular-row').html(insightPopularHtml)

        VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
            max: 2,
            speed: 600
        })
    })

    $('.load-more a').click(function () {
        const $parent = $(this).parent()
        if ($parent.hasClass('loading')) {
            return
        }
        $parent.addClass('loading')
        pageCurrent += 1
        fetchList(pageCurrent, function (err, result) {
            if (err) {
                location.href = '404.html'
                return
            }

            $parent.removeClass('loading')
            if (!result.rows.length) {
                pageCurrent -= 1
                return
            }

            let insightPopularHtml = ''
            result.rows.forEach((item, i) => {
                let html = compBlockCard(item)
                insightPopularHtml += `
                <div class="${i % 5 === 0 ? 'col-sm-8 col-md-8' : 'col-sm-6 col-md-4'} col-xs-12 slideup block-wrap">
                    ${html}
                </div>
            `
            })
            $('#insight-popular-row').append(insightPopularHtml)

            VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
                max: 2,
                speed: 600
            })
        })
    })

    scrollbar.init()
})
